const MIN_STEP_CHARS = 3;
const CATCH_UP_DIVISOR = 15;
const FINISH_TAIL_CHARS = 24;

// One tick of the typewriter reveal: advance the displayed text toward the streamed target at a
// steady word-ish pace, faster when the backlog grows so the display never falls far behind the
// network. Network chunks are lumpy (provider bursts, socket buffering, render pauses) — the smooth
// word-for-word feel comes from this animation, not from wire timing.
export const nextRevealText = (displayed: string, target: string): string => {
  if (!target.startsWith(displayed)) {
    return target;
  }
  const backlog = target.length - displayed.length;
  if (backlog <= FINISH_TAIL_CHARS) {
    return target;
  }
  const step = Math.max(MIN_STEP_CHARS, Math.ceil(backlog / CATCH_UP_DIVISOR));
  const tentativeEnd = displayed.length + step;
  const nextBoundary = target.indexOf(" ", tentativeEnd);
  const end = nextBoundary === -1 ? target.length : nextBoundary;
  return target.slice(0, end);
};
